"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadOptionsSchema = void 0;
const ENABLE_SCRIPT_TYPE_FORMAT = false;
exports.uploadOptionsSchema = [
    {
        title: "アップロード時に無視する行数",
        propertyName: "ignoreLines",
        tooltip: "アップロードされたファイルのうち、無視する行数を指定します。この値はアップロード時に個別に再設定できます。",
        schema: {
            schemaType: "number",
            required: false,
            uiType: "number",
            minValue: 0,
        },
    },
    {
        title: "Script ID の書式",
        propertyName: "scriptIdFormat",
        tooltip: "Script ID の書式を {列名} を使って指定します (例: {id}_{row_no})。列名の他に、 {row_no} と {sheet_name} が使えます。この値はアップロード時に個別に再設定できます。",
        schema: {
            schemaType: "text",
            required: false,
        },
    },
    ...(ENABLE_SCRIPT_TYPE_FORMAT
        ? [
            {
                title: "Script Type の書式",
                propertyName: "scriptTypeFormat",
                tooltip: "Script Type の書式を {列名} を使って指定します (例: {foreign_table}_{foreign_column})。この値はアップロード時に個別に再設定できます。",
                schema: {
                    schemaType: "text",
                    required: false,
                },
            },
        ]
        : []),
    {
        title: "翻訳済みデータの列書式",
        propertyName: "translatedScriptFieldFormat",
        tooltip: "翻訳済みデータの列名の書式を {locale} を使って指定します (例: text{locale})。この値はアップロード時に個別に再設定できます。",
        schema: {
            schemaType: "text",
            required: false,
        },
    },
    {
        title: "翻訳前データの列名",
        propertyName: "originalScriptField",
        tooltip: "翻訳前データの列名を指定します (例: text{locale})。この値はアップロード時に個別に再設定できます。",
        schema: {
            schemaType: "text",
            required: false,
        },
    },
];
